import { Link } from "react-router-dom";

import { PageContainer } from "@/components/core/page-container";
import { buttonVariants } from "@/components/ui/button";
import { ScrollReveal } from "@/components/ui/scroll-reveal";
import type { CtaSection as CtaSectionContent } from "@/types/site";

interface CtaSectionProps {
  content: CtaSectionContent;
}

export function CtaSection({ content }: CtaSectionProps): JSX.Element {
  return (
    <section className="flex flex-col items-center justify-center bg-surface-bright py-20 sm:py-24 md:py-40">
      <ScrollReveal className="w-full" distance="sm">
        <PageContainer className="flex max-w-4xl flex-col items-center space-y-6 text-center sm:space-y-8">
          {content.eyebrow ? (
            <p className="eyebrow">{content.eyebrow}</p>
          ) : null}

          <h2 className="whitespace-pre-line font-display text-[2.15rem] leading-tight tracking-[-0.01em] text-foreground sm:text-[2.5rem] md:text-[3rem]">
            {content.title}
          </h2>

          <p className="mb-2 max-w-2xl text-base font-light leading-7 text-muted-foreground sm:mb-4 sm:text-[1.125rem] sm:leading-relaxed">
            {content.description}
          </p>

          <Link
            className={buttonVariants({
              variant: "outline",
              className:
                "w-full border-accent px-6 py-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-foreground transition-colors duration-300 hover:bg-accent hover:text-white sm:w-auto sm:px-12 sm:py-7 sm:text-xs sm:tracking-[0.2em]",
            })}
            to={content.href}
          >
            {content.label}
          </Link>
        </PageContainer>
      </ScrollReveal>
    </section>
  );
}
